import React from "react";

import { Localized } from "fluent-react/compat";
import config from "../../config";

function Carte() {
  return (
    <div className="container">
      <div className="submit container-link-redirection-mediation">
        <button className="pure-button is-red">
          <a className="link-cart-med" href={config.mediation} target="blank">
            <Localized id="tr-admin-click-here" />
          </a>
        </button>
      </div>
    </div>
  );
}

export default Carte;
